import { fetchApi } from '../../lib/fetchApi';
import { SentimentSelectItem } from '../../types/SentimentSelectItem';

export const getSentiments = async (): Promise<SentimentSelectItem[]> => {
    const response = await fetchApi.get('/sentiment') as SentimentSelectItem[];
    return response;
};
